import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { UserGroupRegistryQueryInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-registry-query.dto';
import type { UserGroupRegistryPageInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-registry-page.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserGroupService extends BaseService {
  protected baseUrl = '/basis/security/user-group';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findRegistryPage(params?: UserGroupRegistryQueryInterface): Observable<UserGroupRegistryPageInterface> {
    return this.http.get<UserGroupRegistryPageInterface>(`${this.baseUrl}/items`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public getHistory(userGroupId: number, params: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${userGroupId}/history`, {
      params: this.objectToHttpParams(params)
    });
  }
}
